cliente.component('cliente.chatComponent', {
    templateUrl: 'components/chat/chat.html',
    controller: 'cliente.chatController',
    controllerAs: '$chat',
    bindings: { config: '<' }
});

cliente.controller('cliente.chatController', ['$scope', 'coreLanguage', 'coreFb', '$filter', '$timeout', function($scope, $text, $fb,  $filter, $timeout) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.message = null;

    $ctrl.data = {};

    const _scrolltoBottom=()=>{
        let chatContainer = document.querySelector('.chat-body');
        if(chatContainer){
            $timeout(()=>{
                chatContainer.scrollTop = chatContainer.scrollHeight;
            },300);
        }

        return;
    };

    const _getConversas=()=>{
        $ctrl.loading = true;

        $ctrl.conversas = [];

        $fb.db.list(`sys_conversas`, [{where:['criacao.idUsuario', '==', $ctrl.idUsuario]}, {where:['idProduto', '==', $ctrl.config.idProduto]}, {limit:[1]}]).then((list)=>{
            if(!list.length){
                $fb.db.add('sys_conversas', {idProduto: $ctrl.config.idProduto}).then(doc=>{
                    return _getConversas();
                });

            }else{
                return new Promise ((resolve, reject)=>{ 
                    const item = list[0];

                    $fb.db.list(`${item.path}/mensagens`, [{orderBy: ['ordem']}])
                    .then((msgList)=>{
                        $ctrl.conversas.push({...item, messages: msgList});

                        let hasConversa = $filter('filter')($ctrl.conversas, {data:{idProduto: $ctrl.config.idProduto}}, true);
                        if(hasConversa.length){
                            $ctrl.data = hasConversa[0];
                        }

                        resolve();

                    }).catch(e=>{ reject(); });

                });
            }

        }).finally(()=>{
            $ctrl.loading = false;
            _scrolltoBottom();
        });
    };

    const _getAiResponse=(idMsg)=>{
        $ctrl.typing = true;

        $fb.functions.invoke('ai_sendMsg', {idConversa: $ctrl.data.id, idMsg: idMsg}).then((list)=>{
            if(!$ctrl.data.messages){ $ctrl.data.messages = []; }

            for(let doc of list){
                $ctrl.data.messages.push(doc);
            }

            $ctrl.typing = false;

            _scrolltoBottom();
        });
    };

    $ctrl.sendMsg=()=>{

        let now = new Date();

        let obj = {
            text: angular.copy($ctrl.message),
            criacao:{data: now},
            ordem: now.getTime(),
            sender: 'user'
        };

        $fb.db.add(`${$ctrl.data.path}/mensagens`, obj).then((doc)=>{
            if(!$ctrl.data.messages){ $ctrl.data.messages = []; }
            $ctrl.data.messages.push({id:doc.id, data: obj});
            $ctrl.message = null;

            _scrolltoBottom();

            return _getAiResponse(doc.id);
        });

    };

    $ctrl.$onInit=()=>{
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idUsuario;
        _getConversas();
    };

}]);